<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card">
                    Descargar registros de afiliaciones
                  </div> 
                </template> 
                <sw-tableget 
                    :filterShow="false"
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGet"
                    route="get_afldescargar"
                    dataRoute="descargar"
                    @save="saveForm"
                    @filtrar="getFiltrar"
                    @pdf="getPdf"
                    >                                      
                    <template v-slot:modal>
                      <sw-modalafldescargar 
                        v-if="openModal.modal.modal==='Descargar'"
                        @save="saveForm">
                      </sw-modalafldescargar>
                      <sw-modalanularregistro 
                        v-if="openModal.modal.modal==='Anular'"
                        @save="saveForm">
                      </sw-modalanularregistro>
                    </template>   
                </sw-tableget>  
            </b-card>           
      </b-col>      
    </b-row>  
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwModalafldescargar from '@/components/modals/aflDescargar.vue'
import SwModalanularregistro from '@/components/modals/anularRegistro.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: "afiliacion_informes",
  components: { 
    SwTableget,
    SwSearchs,
    SwModalafldescargar,
    'c-multiselect': Multiselect,
    SwModalanularregistro
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
